angular.
module("dx.webapp.integrations").
controller("DxSkolonIntegrationsController", function SkolonIntegrationsController(
	dxLocalize,
	dxApiV1Nodes
) {
	"use strict";

	var self = this;

	self.skolonId = "";

	self.skolonEnabled = false;
	self.fieldDisabled = false;

	self.validSkolonId = false;

	self.helpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/sections/360004000734-Skolon" :
		"https://support.digiexam.se/hc/en-us/sections/360004000734-Skolon";

	var skolonIdRegExp = new RegExp("^[a-zA-Z0-9]{50}$");

	self.$onInit = function onInit() {
		dxApiV1Nodes.skolonid.get(self.node.id).then(function success(response) {
			if (response.data) {
				self.skolonId = response.data.skolonId;
				self.skolonEnabled = true;
				self.fieldDisabled = true;
				self.validateSkolonId();
			}
		});
	};

	self.enableSkolon = function enableSkolon() {
		self.skolonEnabled = true;
	};

	self.disableSkolon = function disableSkolon() {
		self.skolonId = "";
		dxApiV1Nodes.skolonid.delete(self.node.id).then(function onResolve() {
			self.skolonEnabled = false;
			self.errorMessage = self.infoMessage = "";
			self.fieldDisabled = false;
		}, function onReject() {
			self.errorMessage = dxLocalize.get("UnknownErrorTryAgain");
		});
	};

	self.validateSkolonId = function validateSkolonId() {
		self.errorMessage = self.infoMessage = "";
		self.validSkolonId = false;

		if (!self.skolonId) {
			self.inputError = "";
			return;
		}

		if (!skolonIdRegExp.test(self.skolonId)) {
			self.inputError = dxLocalize.get("Integrations.Skolon.WrongRegExp");
			return;
		}

		if (self.skolonId.length < 50) {
			self.inputError = dxLocalize.get("Integrations.Skolon.TooShort");
			return;
		}

		self.validSkolonId = true;
		self.inputError = "";
	};

	self.save = function save() {
		self.errorMessage = self.infoMessage = "";

		dxApiV1Nodes.skolonid.put(self.node.id, self.skolonId).then(function skolonIdUpdated() {
			self.validSkolonId = false;
			self.infoMessage = dxLocalize.get("Integrations.Skolon.SaveSuccess");
			self.fieldDisabled = true;
		}, function onErrorResponse(response) {
			if (response.status === 409) {
				self.errorMessage = dxLocalize.get("Integrations.Skolon.SaveConflict");
			} else {
				self.errorMessage = dxLocalize.get("Integrations.Skolon.SaveError");
			}
		});
	};
});
